// Wait for the page to load
window.addEventListener("load", function () {
  // Get all iframe elements on the page
  var iframes = document.querySelectorAll("iframe");

  // Define the base URL to check against
  var baseUrlToMatch = "https://www.google.com/maps";

  // Loop through each iframe and check the src attribute
  for (var i = 0; i < iframes.length; i++) {
    var iframe = iframes[i];

    // Check if the src attribute contains the base URL
    if (iframe.src.startsWith(baseUrlToMatch)) {
      // Add a 'title' attribute to the matching iframe
      iframe.setAttribute("title", "Karta från Google Maps");
    }
    if (iframe.src.startsWith("https://www.hitta.se/kartan")) {
      iframe.setAttribute("title", "Karta från hitta.se");
    }
    if (iframe.src.startsWith("https://www.dreambroker.com")) {
      iframe.setAttribute("title", "Video från dreambroker");
    }
    if (iframe.src.startsWith("//www.youtube.com/embed")) {
      iframe.setAttribute("title", "Video från youtube");
    }
  }
});
